export default __webpack_public_path__ + "static/FS2S-InHub-136-9a5f9e6977313ee66e5820e5dcc9a89b.jpg";